import './App.css';
import HomePage from './home/HomePage.tsx';
import Login from './login/Login.tsx';

import Privacy from './privacy/Privacy.tsx';
import Terms from './terms/Terms.tsx';

import Signup from './signup/Signup.tsx';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />

          <Route path="/marketing" element={<HomePage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />

          <Route index element={<HomePage />} />
          <Route path="lab/login" element={<Login />} />
          {/* <Route path="lab/access" element={<TheDezLab />} /> */}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
